import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `DossierStatus/CreateRentingChargedListUpdate?DossierId=${dossierId}`, method: 'PUT', body: null, token: token })
}
